'use client';

import React from 'react';

const items = [
  'Vehicle Diagnostics',
  'EV Repair & Inspection',
  'Engine Service',
  'Brake Repair',
  'Wheel Alignment',
  'Electrical Systems Repairing',
  'Transmission Service',
  'Oil Change',
  'Suspension Repair',
  'Battery Installation',
  'Pre-Purchase Inspection',
  'Radiator Repair',
  'Mechanical Systems Repairing',
  'Body Repairing & Painting',
  'Tire Change & Repairing',
  'Consulting During Vehicle Purchase',
];

export default function MarqueeBanner() {
  return (
    <div data-component-id="src/app/homepage/components/MarqueeBanner.tsx:26:4" data-component-path="src/app/homepage/components/MarqueeBanner.tsx" data-component-line="26" data-component-end-line="76" data-component-file="MarqueeBanner.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22py-4%20overflow-hidden%22%7D"
      className="py-4 overflow-hidden"
      style={{
        background: '#c60000',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
      }}
    >
      <div data-component-id="src/app/homepage/components/MarqueeBanner.tsx:34:6" data-component-path="src/app/homepage/components/MarqueeBanner.tsx" data-component-line="34" data-component-end-line="75" data-component-file="MarqueeBanner.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22marquee-container%22%7D" className="marquee-container">
        <div data-component-id="src/app/homepage/components/MarqueeBanner.tsx:35:8" data-component-path="src/app/homepage/components/MarqueeBanner.tsx" data-component-line="35" data-component-end-line="54" data-component-file="MarqueeBanner.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22marquee-track%22%7D" className="marquee-track">
          {[...items, ...items]?.map((item, i) => (
            <span data-component-id="src/app/homepage/components/MarqueeBanner.tsx:37:12" data-component-path="src/app/homepage/components/MarqueeBanner.tsx" data-component-line="37" data-component-end-line="52" data-component-file="MarqueeBanner.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22inline-flex%20items-center%20gap-4%20px-6%22%7D"
              key={i}
              className="inline-flex items-center gap-4 px-6"
              style={{
                color: 'white',
                fontSize: '12px',
                fontFamily: 'JetBrains Mono, monospace',
                fontWeight: 500,
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                whiteSpace: 'nowrap',
              }}
            >
              <span data-component-id="src/app/homepage/components/MarqueeBanner.tsx:50:14" data-component-path="src/app/homepage/components/MarqueeBanner.tsx" data-component-line="50" data-component-end-line="50" data-component-file="MarqueeBanner.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22%E2%97%86%22%7D" style={{ opacity: 0.5 }}>◆</span>
              {item}
            </span>
          ))}
        </div>
        <div data-component-id="src/app/homepage/components/MarqueeBanner.tsx:55:8" data-component-path="src/app/homepage/components/MarqueeBanner.tsx" data-component-line="55" data-component-end-line="74" data-component-file="MarqueeBanner.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22marquee-track%22%7D" className="marquee-track" aria-hidden="true">
          {[...items, ...items]?.map((item, i) => (
            <span data-component-id="src/app/homepage/components/MarqueeBanner.tsx:57:12" data-component-path="src/app/homepage/components/MarqueeBanner.tsx" data-component-line="57" data-component-end-line="72" data-component-file="MarqueeBanner.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22inline-flex%20items-center%20gap-4%20px-6%22%7D"
              key={i}
              className="inline-flex items-center gap-4 px-6"
              style={{
                color: 'white',
                fontSize: '12px',
                fontFamily: 'JetBrains Mono, monospace',
                fontWeight: 500,
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                whiteSpace: 'nowrap',
              }}
            >
              <span data-component-id="src/app/homepage/components/MarqueeBanner.tsx:70:14" data-component-path="src/app/homepage/components/MarqueeBanner.tsx" data-component-line="70" data-component-end-line="70" data-component-file="MarqueeBanner.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22%E2%97%86%22%7D" style={{ opacity: 0.5 }}>◆</span>
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}